import { CheckIcon, PlusSmallIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface Props {
  selected: boolean;
  onSelect: () => void;
}

const Select: React.FC<Props> = ({ selected, onSelect }) => {
  const icon = selected ? (
    <CheckIcon width={12} className="stroke-2 text-white" />
  ) : (
    <PlusSmallIcon width={14} className="stroke-2 text-gray-400" />
  );
  return (
    <div>
      <div
        className={`flex h-[18px] w-[18px] items-center justify-center rounded-xl border-2 border-solid ${
          selected ? 'bg-primary-600 border-primary-600' : 'border-gray-300 bg-transparent'
        }`}
        onClick={onSelect}
      >
        {icon}
      </div>
    </div>
  );
};

export default Select;
